<template>
    <div class="payApplyModalWrap">
        <div class="mask" @click="closeModal"></div>
        <div class="payModalBox">
            <div class="title">填写打款信息</div>
            <div class="modalContent">
                <div class="oneArea twoArea">
                    <!-- 清算付款显示的 -->
                    <div v-if="isLiquidation">
                    </div>
                    <!-- 下单状态 申请 给销售商打款 -->
                    <div v-if="!isLiquidation">

                    </div>
                    <div class="oneline"><span class="mylabel">本次申请额度：</span><span class="text">{{infoObj.maxNumber}}元</span></div>
                    <div class="oneline">
                      <span class="mylabel"> <i class="red">*</i> 本次应打款金额：</span>
                      <input type="text" placeholder="请输入金额(只能等于申请额度)" v-model="number" style="width: 200px;">元
                    </div>
                </div>
                <div class="oneArea">
                    <div class="oneline">
                        <el-upload v-if="imgsArr.length<5"
                          class="upload_mock_Btn"
                          :action="uploadFileApi"
                          name="files"
                          drag
                          :data="uploadData"
                          :show-file-list="false"
                          :on-success="(res, file) => {return handleImgSuccess(res, file)}"
                          :before-upload="beforeImgUpload"
                          accept="image/*">
                          <div class="el-upload__text"> <em>上传凭证</em> 或拖拽图片到此处</div>
                        </el-upload>
                        <span style="margin-left: 10px;font-size: 12px;color:#aaa;">拖拽图片到此处或点击上传；最多上传5张； 每张图片不超过5M</span>
                    </div>
                    <div class="oneline">
                        <div class="oneImgBox" v-for="(list,index) in imgsArr">
                            <el-image
                              class="uploadImgAvatar"
                              :src="list.wei_url"
                              fit="contain"
                              :preview-src-list="[list]"
                            ></el-image>
                            <div class="imgDeleteBox"  @click="deleteImg(index)"><i class="el-icon-delete" style="margin-right:5px"></i>删除</div>
                        </div>

                    </div>
                </div>
                <div class="oneArea">
                    <div class="oneline">
                        <span class="mylabel">付款说明：</span>
                        <br>
                        <textarea name="" id="" cols="48" rows="5" placeholder="请输入说明,最多300字" v-model="memo"></textarea>
                    </div>
                </div>
            </div>

            <div class="footer">
                <button class="closeBtn btn" @click="closeModal">取消</button>
                <button class="submitBtn btn" @click="submitClick">确定</button>
            </div>
        </div>

    </div>
</template>

<script>
    import { ajaxPost, api } from "@/common/request.js";
    import { json, wordData, utils } from "@/common/common.js";
    export default {
        name: 'pay',
        props: ["info","isLiquidation"],
        computed: {
            infoObj() {
               this.number= this.info.maxNumber
                return this.info
            },
            adminId() {
              return utils.getAdminId()
            },
        },
        data() {
            return {
                imgsArr:[],//图片数组
                number: "",
                memo:'',

                // 上传图片api
                uploadFileApi: api.baseUrl + '/file/uploadfilebatch',
                uploadData: {
                  imageType: 12201,
                  imageUserId:'',
                },

            }
        },
        watch: {},
        methods: {
            deleteImg(index){
              this.imgsArr.splice(index,1)
            },
            // 图片上传成功
            handleImgSuccess(res, file) {
              console.log(res, file)
              if (res.errorCode == 200) {
                  let buffer={
                      wei_url:URL.createObjectURL(file.raw),
                      imageFiles:res.data.imageFiles,
                      imgId: res.data.imgId
                  }
                  this.imgsArr.push(buffer)
                  console.log(this.imgsArr)
                // this.ruleForm['imgItem_' + NUM] = res.data
                // this.ruleForm['imageUrl_' + NUM] = URL.createObjectURL(file.raw);
                // if (NUM == '1') {
                //   this.$refs['ruleForm'].clearValidate('imageUrl_1')
                // }

              }
            },
            beforeImgUpload(file) {
              console.log(file)

              const isImg = /^image\/*/.test(file.type)
              const isLt5M = file.size / 1024 / 1024 < 5
              if (!isImg) {
                this.$message.error('只能上传图片!');
              }
              if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB!');
              }
              return isImg && isLt5M;
            },
            // handleRemove(file, fileList) {
            //     console.log(file, fileList);
            // },
            // handlePreview(file) {
            //     console.log(file);
            // },
            closeModal() {
                this.number = ''
                this.$emit("close")
            },
            closeModalAndSuccess() {
                this.number = ''
                this.$emit("success")
                this.
                initModal()
            },
            initModal(){
                this.imgsArr=[]//图片数组
                this.number=""
                this.memo=''
            },
            submitClick() {
                let _this = this
                let imgNewArr=this.imgsArr.map(function(item,index){
                    let buffer={
                        imageFiles: item.imageFiles,
                        imgId:item.imgId
                    }
                    return buffer
                })
                if (!this.number) {
                    this.$message.error('金额不能为空')
                } else if (this.number <= 0) {
                    this.$message.error('金额不能为0')
                } else if (isNaN(this.number)) {
                    this.$message.error('金额只能为数字')
                }
                else if (Number(this.number)  != Number(_this.infoObj.maxNumber) ) {
                    this.$message.error('打款金额必须等于总额度')
                }
                else {
                    if(!this.isLiquidation){//下单的付款
                        let arg = {
                            purchaseOrderId: _this.infoObj.purchaseOrderId,
                            supplierUserId: _this.infoObj.supplierUserId,
                            dealerUserId: _this.infoObj.dealerUserId,
                            itemId: _this.infoObj.itemId,
                            imgJson:JSON.stringify(imgNewArr),
                            orderTransferAmount: _this.number,
                            orderTransferMemo:_this.memo,
                            billOrderId:_this.infoObj.billOrderId,
                            adminId:this.adminId,

                        }
                        console.log(arg)
                        ajaxPost("/dwOrder/saveRequestPaymentByOrder",arg).then(res => {
                            console.log(res)
                            if (res.errorCode == 200) {
                                this.$message.success("提交打款凭证成功")
                                _this.closeModalAndSuccess()
                            } else {
                                this.$message.error(res.errorMsg)
                            }
                        })
                    }else{//这里是清算打款
                        let arg = {
                          liquidateOrderId: _this.infoObj.liquidateOrderId,
                          supplierUserId: _this.infoObj.supplierUserId,
                          dealerUserId: _this.infoObj.dealerUserId,
                          itemId: _this.infoObj.itemId,
                          imgJson:JSON.stringify(imgNewArr),
                          orderTransferAmount: _this.number,
                          orderTransferMemo:_this.memo,
                          billOrderId:_this.infoObj.billOrderId,
                          adminId:this.adminId,
                        }
                        console.log(arg)
                        ajaxPost("/dwOrder/saveRequestLqPayment",arg).then(res => {
                            console.log(res)
                            if (res.errorCode == 200) {
                                this.$message.success("提交打款凭证成功")
                                _this.closeModalAndSuccess()
                            } else {
                                this.$message.error(res.errorMsg)
                            }
                        })
                    }

                }
            }
        },
        created() {
          this.uploadData.imageUserId = this.adminId
        },
        mounted() {

        }
    }
</script>

<style scoped="scoped" lang="scss">
    textarea{border-radius: 4px;border:1px solid #C4C6CF;padding:6px 9px ;margin-top:8px;}
    .payApplyModalWrap {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;

        .oneImgBox:hover{border-color: red;}
        .oneImgBox{
            display: inline-block; border:1px dashed #ccc;margin-right: 15px;position: relative;

            .uploadImgAvatar{
               width: 120px;height: 120px;
               img{max-width: 100%;max-height: 100%;}
            }
            .imgDeleteBox{
                position: absolute;cursor: pointer;
                width: 100%; text-align: center;background: rgba(0,0,0,0.3);color:#ddd;bottom:0px;font-size: 12px;padding:5px 0;
            }
            .imgDeleteBox:hover{color:red;background: rgba(0,0,0,0.7);}
        }

        .mask {
            background: rgba(0, 0, 0, 0.5);
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .modalContent{
            padding:0 24px;
        }
        .payModalBox {
            position: fixed;
            z-index: 1000;
            left: 25%;
            top: 3%;
            max-height: 95%;
            width: 50%;
            min-width: 460px;
            overflow: auto;
            border: 1px solid #eee;
            border-radius: 4px;
            background: #fff;
            border-radius: 2px;

            input {
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 8px;
            }

            .title {
                font-size: 18px;
                padding: 19px 25px;
                border-bottom: 1px solid #eee;
            }

            .oneArea {
                margin: 20px 0;
            }

            .oneline {
                margin: 8px 0;
                color:#000;opacity: 0.85;font-size: 16px;
            }

            .firstArea {
                .oneline {
                }
            }
            .twoArea{
                background: #f9f9f9;padding:16px 24px;
                .oneline {
                    margin: 4px 0; color:#333;opacity: 1;
                }
            }

            .mylabel {}

            .text {}

            .footer {
                text-align: right;
                border-top: 1px solid #eee;
                padding: 14px 25px;

                .btn {
                    padding: 5px 16px;
                    background: #fff;
                    font-size: 12px;
                    border-radius: 4px;
                }

                .closeBtn {
                    margin-right: 10px;
                    border: 1px solid #D9D9D9;
                }

                .submitBtn {
                    background: #F81D22;
                    color: #fff;
                    border: 0;
                }
            }
        }
    }


</style>
<style>
  .upload_mock_Btn .el-upload-dragger {
      width: 88px;
      height: 88px;
      border-color: #aaa;
  }
  .el-upload-dragger {
      background-color: #fff;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      box-sizing: border-box;
      width: 360px;
      height: 180px;
      text-align: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;
  }
  .upload_mock_Btn .el-upload-dragger .el-upload__text {
      margin-top: 28px;
      line-height: 1.5;
      font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/paymodal_apply.vue